import PaymentCorporateAddress from './PaymentCorporateAddress';

export default PaymentCorporateAddress;
